import { render, staticRenderFns } from "./TabTransfers.vue?vue&type=template&id=4698c280&lang=pug&"
import script from "./TabTransfers.vue?vue&type=script&lang=js&"
export * from "./TabTransfers.vue?vue&type=script&lang=js&"
import style0 from "./TabTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports